import Main from './Main.vue'

const routes = [{ name: 'dashboard/main', component: Main, path: '/home' }]

export { routes }
